import AnalisiRischiThList from "./pages/AnalisiRischiThList";
import AnalisiRischiThView from "./pages/AnalisiRischiThView";
import AnalisiRischiThEdit from "./pages/AnalisiRischiThEdit";
export default {
    AnalisiRischiThList,
    AnalisiRischiThView,
    AnalisiRischiThEdit,
};
